import styled from "styled-components";

/* https://codepen.io/ChrisAwesome/pen/yNdMEP */
/* Windows 10 inspired pure CSS switch by ChrisAwesome */

const FormWrapper = styled.form`
  textarea {
    resize: vertical;
  }
  label {
    line-height: 1em;
    > p {
      line-height: 1em;
    }
    *::placeholder {
      color: ${(props) => props.theme.colors.nero};
    }
    display: block;
    padding: 10px 20px;
    &.requried {
      p {
        &:after {
          content: "*";
          padding: 10px;
          color: ${(props) => props.theme.colors.monteCarlo};
        }
      }
    }
  }
  input:not(:placeholder-shown):not([value=""]):not(:focus):invalid {
    outline: 2px solid ${(props) => props.theme.colors.cardinal};
  }
  input,
  textarea,
  select {
    border: 1px solid ${(props) => props.theme.colors.black};
    color: ${(props) => props.theme.colors.text};
    background: ${(props) => props.theme.colors.white};
    display: block;
    width: 100%;
    padding: 10px;
    :focus {
      outline: 2px solid
        ${(props) =>
          props.bg
            ? props.theme.colors[props.bg]
            : props.theme.colors.monteCarlo};
    }
  }
  select {
    appearance: none;
    padding-right: 45px;
    background-image: linear-gradient(
        45deg,
        transparent 50%,
        ${(props) => props.theme.colors.nero} 50%
      ),
      linear-gradient(
        135deg,
        ${(props) => props.theme.colors.nero} 50%,
        transparent 50%
      ),
      linear-gradient(
        to right,
        ${(props) => props.theme.colors.nero},
        ${(props) => props.theme.colors.nero}
      );
    background-position: calc(100% - 20px) calc(1em + 2px),
      calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.6em;
    background-size: 5px 5px, 5px 5px, 1px 1.5em;
    background-repeat: no-repeat;
    &::-ms-expand {
      display: none;
    }
  }
  .checkbox-switch {
    display: inline-block;
    input[type="checkbox"] {
      width: 0;
      height: 0;
      overflow: hidden;
      display: none;
      &:focus {
      }
      &:checked + label {
        &:before {
          border-color: ${(props) => props.theme.colors.cerulean};
          background: ${(props) => props.theme.colors.cerulean};
          text-align: right;
          color: white;
        }
        &:active {
          &:before {
            border-color: ${(props) => props.theme.colors.delta};
            background: ${(props) => props.theme.colors.delta};
            color: white;
          }
        }
      }
    }
    margin: 0;
    padding: 0;
    border: 0;
    padding-top: 14px;
    &:after {
      content: "";
      display: table;
      clear: both;
    }
    legend {
      margin: 0;
      padding: 0;
      display: block;
      font-size: 1.2rem;
      line-height: 1.3rem;
    }
    legend.legend-right {
      margin: 0 0.618rem 0 0;
      float: right;
    }
    .checkbox-right {
      float: right;
    }
    input[type="checkbox"] + label {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      line-height: 1.3rem;
      padding: 0;
      &:before {
        width: 2.3rem;
        height: 1.3rem;
        display: inline-block;
        content: "•";
        transition: all 0.2s ease;
        text-align: left;
        font-size: 2.25rem;
        line-height: 1rem;
        float: left;
        overflow: hidden;
        color: ${(props) => props.theme.colors.text};
        border: 0.1949902505rem solid ${(props) => props.theme.colors.text};
        border-radius: 0.65rem;
        margin: auto 0;
      }
      &:after {
        display: none;
      }
      &:active {
        &:before {
          border-color: ${(props) => props.theme.colors.delta};
          background: ${(props) => props.theme.colors.delta};
          color: white;
        }
      }
    }
  }
`;
// &:after {
//   content: ">";
//   font-size: 16px;
//   color: ${(props) => props.theme.colors.text};
//   transform: rotate(90deg);
//   right: 11px;
//   top: 18px;
//   padding: 0 0 2px;
//   position: absolute;
//   pointer-events: none;
//   width: 10px;
//   height: 10px;
// }

export { FormWrapper };
